/**
 * Runtime supplemental API may return one pipeline template row (no `statusReportItemId`)
 * instead of one row per report line. Expand to virtual sources per line so matching and
 * grouping behave like the legacy payload.
 *
 * Use `matchConfig.value: "$codeName"` (or `$statusReportItemId`) so each line only
 * receives its own pipeline rows. Literal values would apply the same filter to every line.
 */
export function expandSupplementalPipelineSources (supplementalSources, itemByStatusReportItemId) {
  if (!supplementalSources?.length) return []
  const lines = Array.from(itemByStatusReportItemId.values())
  const out = []

  for (const src of supplementalSources) {
    if (!src?.sourceType || !src.sourceKey) continue

    if (src.statusReportItemId != null) {
      out.push(src)
      continue
    }

    for (const line of lines) {
      if (line?.statusReportItemId == null) continue
      const baseId = src.supplementalSourceId
      out.push({
        ...src,
        statusReportItemId: line.statusReportItemId,
        supplementalSourceId: baseId != null
          ? `${baseId}-${line.statusReportItemId}`
          : `tmpl-${src.sourceKey}-${line.statusReportItemId}`
      })
    }
  }

  return out
}
